import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { Ncm, Page } from '../../../models/cadastro.model';
import { CadastroService } from '../../../services/cadastro.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalStateService } from '../../../services/modaState.service';

@Component({
  selector: 'app-ncm-modal',
  imports: [CommonModule, FormsModule],
  standalone: true,
  templateUrl: './ncm-modal.html',
  styleUrl: './ncm-modal.css'
})
export class NcmModal implements OnInit {

  ngOnInit(): void {
    this.resetForm();
  }

  @Input() isOpen = false;
  @Output() closeModal = new EventEmitter<void>();

  modalStateService = inject(ModalStateService);
  cadastroService = inject(CadastroService);
  selectedNcm: Ncm = this.getNewNcm();

  termo: string = '';
  ncmPage: Page<Ncm> | undefined;
  page = 0;
  size = 5;

  // Pagination
  maxPagesToShow = 5;
  startPage!: number;
  endPage!: number;
  pages: number[] = [];

  search() {
    this.cadastroService.getNcmGenerico(this.termo, this.page, this.size).subscribe(response => {
      this.ncmPage = response;
      this.updatePageNumbers();
    });
  }

  selectNcm(ncm: Ncm): void {
    this.selectedNcm = ncm;
  }

  inserirNcm(): void {
    this.isOpen = false;
    this.modalStateService.close(this.selectedNcm);
    this.closeModal.emit();
  }

  onPageChange(page: number) {
    this.setPage(page);
  }

  setPage(page: number): void {
    if (page < 0 || (this.ncmPage && page >= this.ncmPage.totalPages)) {
      return;
    }
    this.page = page;
    this.search();
  }

  updatePageNumbers(): void {
    if (!this.ncmPage) {
      return;
    }

    const totalPages = this.ncmPage.totalPages;
    const currentPage = this.page;
    const maxPages = this.maxPagesToShow;

    let startPage: number, endPage: number;

    if (totalPages <= maxPages) {
      startPage = 0;
      endPage = totalPages - 1;
    } else {
      const maxPagesBeforeCurrent = Math.floor(maxPages / 2);
      const maxPagesAfterCurrent = Math.ceil(maxPages / 2) - 1;

      if (currentPage <= maxPagesBeforeCurrent) {
        startPage = 0;
        endPage = maxPages - 1;
      } else if (currentPage + maxPagesAfterCurrent >= totalPages) {
        startPage = totalPages - maxPages;
        endPage = totalPages - 1;
      } else {
        startPage = currentPage - maxPagesBeforeCurrent;
        endPage = currentPage + maxPagesAfterCurrent;
      }
    }

    this.pages = Array.from(Array((endPage - startPage) + 1).keys()).map(i => startPage + i);
  }

  public onClose(): void {
    this.isOpen = false;
    this.closeModal.emit();
  }

  public resetForm(): void {
    this.termo = '';
  }

  private getNewNcm(): Ncm {
    return {
      id: 0,
      codigo: '',
      descricao: ''
    };
  }
}
